import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

interface GraphDetails {
    allData: (data: any[]) => void;
}

const MuscleSorenessGraph: React.FC<GraphDetails> = ({ allData }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [sorenessData, setSorenessData] = useState<any>([]);

    useEffect(() => {
        async function fetchMetrics() {
            setIsLoading(true);
            setSorenessData(allData.muscleSoreness || []);

            setIsLoading(false);
        }
        fetchMetrics();
    }, [allData]);

    // Helper for date → DD-MM-YYYY
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = String(d.getFullYear()).slice(-2);
        return `${day}-${month}-${year}`;
    };

    // If data not loaded, return nothing
    if (!sorenessData.muscleSoreness || !sorenessData.muscleSoreness_avg || !sorenessData.x_axis) {
        return <div className="text-center">{sorenessData.error}</div>;
    }
    // Safe mapping (prevents map undefined error)

    const sorenessValues = Array.isArray(sorenessData.muscleSoreness) ? sorenessData.muscleSoreness.map(Number) : [];
    const sorenessAvgValues = Array.isArray(sorenessData.muscleSoreness_avg) ? sorenessData.muscleSoreness_avg.map(Number) : [];
    const labelMap = Array.isArray(sorenessData.metricscale)
        ? sorenessData.metricscale.reduce((acc: Record<string, string>, item: any) => {
            const [key, value] = Object.entries(item)[0];
            // acc[key] = value as string;
            acc[Number(key).toString()] = value as string;
            return acc;
        }, {})
        : {};


    const start = new Date(sorenessData.x_axis.min);
    const oneDay = 24 * 60 * 60 * 1000;
    const dates = Array.isArray(sorenessData.x_axis) ? sorenessData.x_axis : [];

    // Create series with STRING DATES
    const barData = sorenessValues.map((value, i) => ({
        // x: formatDate(new Date(start.getTime() + i * oneDay)),
        x: formatDate(dates[i]),
        y: value
    }));

    const lineData = sorenessAvgValues.map((value, i) => ({
        // x: formatDate(new Date(start.getTime() + i * oneDay)),
        x: formatDate(dates[i]),
        y: value
    }));

    const optionsBar = {
        chart: {
            type: "line",
            stacked: false,
            height: 350,
            toolbar: { show: false }
        },

        series: [
            {
                name: "Muscle Soreness",
                type: "bar",
                data: barData,
                color: "#1eb0d5"
            },
            {
                name: "Muscle Soreness Average",
                type: "line",
                data: lineData,
                color: "#24c80b"
            }
        ],

        plotOptions: {
            bar: {
                columnWidth: "40%",
                borderRadius: 4,
                dataLabels: { enabled: false }
            }
        },

        stroke: {
            width: [0, 3],
            curve: "smooth"
        },

        xaxis: {
            type: "category",   // IMPORTANT → shows date as string
            labels: {
                rotate: 0,
                style: { colors: "#777" }
            }
        },

        yaxis: {
            min: -2,
            max: 2,
            tickAmount: 4,
            labels: {
                // formatter: (val: number) => val.toFixed(0),
                formatter: (val: number) => {
                    const key = Math.round(val).toString();

                    return labelMap[key] || "";
                },
                style: { colors: "#777" }
            }
        },

        dataLabels: { enabled: false },

        legend: { show: false }
    };

    return (
        <div id="bar">
            <ReactApexChart
                options={optionsBar}
                series={optionsBar.series}
                type="line"
                height={250}
                width="100%"
            />
        </div>
    );
};

export default MuscleSorenessGraph;
